import * as React from "react";
import EmailForm from "../form/email/email-form";
import styled from "styled-components";
import { defaultFontStack } from "../../styles/typography/v2/font-stack";
import { Script } from "gatsby";

const Root = styled.div(defaultFontStack, ({ theme }) => ({
  backgroundColor: "#000000",
  color: theme.colors.day,
  padding: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  "@media(min-width: 800px)": {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const Title = styled.span({
  fontSize: 25,
  fontWeight: 700,
  display: "block",
  marginBottom: 10,
});

const Description = styled.span({
  fontSize: 21,
  fontWeight: 400,
  display: "block",
});

const WatchNowButton = styled.button({
  minWidth: "fit-content",
  width: "fit-content",
  border: "2px solid white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 5,
  fontWeight: 600,
  borderRadius: 40,
  backgroundColor: "#1070c0",
  padding: 10,
});

const ButtonContainer = styled.div({
  display: "flex",
  alignItems: "center",
});

export function OEEBanner() {
  const [submitted, setSubmitted] = React.useState(false);

  const onSubmit = () => {
    setSubmitted(true);
    window.Wistia.api("fi471vh0c7").play();
  };

  const onWatch = () => {
    window.Wistia.api("fi471vh0c7").play();
  };

  return (
    <Root data-component-name="oee-banner">
      <div style={{ maxWidth: 450 }}>
        <Title>10 Ways to Rapidly Improve OEE</Title>
        <Description>
          Get instant access to our exclusive 30-minute video presentation on
          the <strong>5 Deadly Sins</strong> and <strong>5 Quick Wins</strong>{" "}
          of OEE.
        </Description>
      </div>
      {submitted ? (
        <ButtonContainer>
          <WatchNowButton onClick={onWatch}>
            Watch Now{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20"
              width="20"
              fill="white"
              viewBox="0 0 448 512"
            >
              <path d="M422.6 278.6L445.3 256l-22.6-22.6-144-144L256 66.7 210.8 112l22.6 22.6L322.8 224 32 224 0 224l0 64 32 0 290.7 0-89.4 89.4L210.8 400 256 445.3l22.6-22.6 144-144z"></path>
            </svg>
          </WatchNowButton>
        </ButtonContainer>
      ) : (
        <EmailForm
          onSubmit={onSubmit}
          formId="90b9e28e-5287-ef11-ac21-7c1e5201228e"
        />
      )}
      <div class="wistia_embed wistia_async_fi471vh0c7 popover=true popoverAnimateThumbnail=true"></div>
      <Script src="https://fast.wistia.com/embed/medias/fi471vh0c7.jsonp" />
      <Script src="https://fast.wistia.com/assets/external/E-v1.js" />
    </Root>
  );
}
